// Shared option lists for the student and tutor profile forms (Profile*
// SetupPage and ProfilePage's editable cards) — DRY: defined once, used by
// both roles' pages.
import type { ComponentType, SVGProps } from "react";
import type { PreferredPaymentMethod, Profession, Specialisation } from "@dm-lms/shared/types";
import { IconDeviceMobile, IconBuildingBank, IconCreditCard, IconDots } from "../components/shared/icons.js";

export const PAYMENT_OPTIONS: Array<{
  value: PreferredPaymentMethod;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
}> = [
  { value: "mpesa", label: "M-Pesa", Icon: IconDeviceMobile },
  { value: "bank_transfer", label: "Bank transfer", Icon: IconBuildingBank },
  { value: "card", label: "Card", Icon: IconCreditCard },
  { value: "other", label: "Other", Icon: IconDots },
];

export const PROFESSION_OPTIONS: Array<{ value: Profession; label: string }> = [
  { value: "advocate", label: "Advocate" },
  { value: "hr_professional", label: "HR professional" },
  { value: "court_staff", label: "Court staff" },
  { value: "mediator", label: "Mediator" },
  { value: "other", label: "Other" },
];

export const SPECIALISATION_OPTIONS: Array<{ value: Specialisation; label: string }> = [
  { value: "commercial", label: "Commercial mediation" },
  { value: "family", label: "Family mediation" },
  { value: "labour", label: "Labour disputes" },
  { value: "community", label: "Community mediation" },
  { value: "other", label: "Other" },
];

export function specialisationLabel(value: Specialisation | null): string {
  if (!value) return "—";
  return SPECIALISATION_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

// Kenya's 47 counties, alphabetical.
export const KENYA_COUNTIES = [
  "Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet", "Embu", "Garissa",
  "Homa Bay", "Isiolo", "Kajiado", "Kakamega", "Kericho", "Kiambu", "Kilifi",
  "Kirinyaga", "Kisii", "Kisumu", "Kitui", "Kwale", "Laikipia", "Lamu",
  "Machakos", "Makueni", "Mandera", "Marsabit", "Meru", "Migori", "Mombasa",
  "Murang'a", "Nairobi", "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua",
  "Nyeri", "Samburu", "Siaya", "Taita-Taveta", "Tana River", "Tharaka-Nithi",
  "Trans Nzoia", "Turkana", "Uasin Gishu", "Vihiga", "Wajir", "West Pokot",
];

export const ORGANISATION_HINT = "Employer or organisation. Write 'Self-employed' if none.";
export const REGION_LABEL = "City, state or county";

// Where a country's flag image lives (apps/web/public/flags/<iso alpha-2, lowercase>.svg).
// The only place this path format is defined.
export function flagSrc(code: string): string {
  return `/flags/${code.toLowerCase()}.svg`;
}
